import { DynamicComponent } from '@priva/components/dynamic';

export interface AppState {
    activeDialogs: DynamicComponent[];
}

export const initialAppState: AppState = {
    activeDialogs: [],
};
